import { useCallback, useEffect, useState } from "react";
import { useActiveNafList } from "../../../../../../hooks/fetchers/useActiveNafList/useActiveNafList";
import Modal from "../../../../../commons/Modal/Modal"
import { ModalSizes } from "../../../../../commons/Modal/Modal.types"
import { EditSubscriptionsModalProps } from "./EditSubscriptionsModal.types"
import { SelectOption } from "../../../../../commons/Select/Select.types";
import EditSubscriptionRow from "./EditSubscriptionRow/EditSubscriptionRow";
import Button from "../../../../../designSystem/Button/Button";
import { ButtonColor } from "../../../../../designSystem/Button/Button.types";
import { BaseResponse } from "../../../../../../types/api/api.types";
import { useMutation, useQueryClient } from "react-query";
import { UPDATE_NAF_QUERY_KEY, updateNAFQuery } from "./EditSubscriptionsModal.query";
import { useNavigate } from "react-router-dom";

export default ({ domains, ...props }: EditSubscriptionsModalProps) => {

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { data: NAFList } = useActiveNafList();

  const [choosedNAFCodes, setChoosedNAFCodes] = useState<(SelectOption | null)[]>([null]);

  const onChange = useCallback(
    (indexToUpdate: number, data: SelectOption) => {
      const updatedItems = choosedNAFCodes.reduce(
        (acc, item, index) => {
          if (index === indexToUpdate) {
            return [...acc, data];
          } else {
            return [...acc, item];
          }
        },
        [] as (SelectOption | null)[]
      );
      setChoosedNAFCodes(updatedItems);
    },
    [choosedNAFCodes]
  );

  const onAdd = useCallback(() => {
    setChoosedNAFCodes([...choosedNAFCodes, null]);
  }, [choosedNAFCodes]);

  useEffect(() => {
    console.log('choosedNAFCodes', choosedNAFCodes)
  }, [choosedNAFCodes])

  useEffect(() => {
    if (domains) {
      setChoosedNAFCodes([
        ...domains.map(([id, domain]) => ({
          value: id.toString(),
          label: domain
        })),
        ...(domains.length < 4 ?
          Array(3 - domains.length).map(() => null) :
          []
        )
      ])
    }
  }, [domains])

  const { mutate: updateNAF, isLoading } = useMutation<
    Awaited<BaseResponse>,
    Error,
    string[]
  >((data) => updateNAFQuery(data), {
    mutationKey: UPDATE_NAF_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: () => {
      navigate(0)
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  if (!domains) return null

  return (
    <Modal 
      closeOnClickOutside 
      size={ModalSizes.Small}
      {...props}
    >
      {domains.map(([id, domain], index) => (
        <EditSubscriptionRow
          key={index} 
          {...{
            index,
            NAFList,
            choosedNAFCodes,
            onChange,
            onAdd
          }}
          defaultValue={{
            value: id.toString(),
            label: domain
          }}
        />
      ))}
      {(domains.length < 3) && [...Array(3 - domains.length)].map((_, index) => (
        <EditSubscriptionRow
          key={index + domains.length} 
          {...{
            index: index + domains.length,
            NAFList,
            choosedNAFCodes,
            onChange,
            onAdd
          }}
        />
      ))}
      <Button
        color={ButtonColor.Secondary}
        style={{
          alignSelf: 'unset',
          textAlign: 'center',
          borderRadius: 6,
          marginBottom: 'var(--spacing-s)',
          width: 'calc(100% - var(--spacing-m))',
          paddingLeft: 0,
          paddingRight: 0,
        }}
        onClick={(e) => {
          e.preventDefault()
          if (choosedNAFCodes) {
            updateNAF(choosedNAFCodes.map(item => item?.value || ''))
          }
        }}
        isLoading={isLoading}
      >
        Valider
      </Button>
    </Modal>
  )
}